<template>
  <div class="home">
    <div v-if="loading" class="loader"></div>
    <div class="choose-model">
      <div style="width:200px;display:inline-block;margin-right:20px;">
        <el-input v-model="input" placeholder="请输入编码"></el-input>
      </div>
      <div class="btn-item" @click="queryResult">查询</div>

      <div :class="modelChoose === 'model1' ? 'choose-item btn-item type_item' : 'btn-item type_item'"
        @click="changeModel('model1')">钻石</div>
      <div :class="modelChoose === 'model2' ? 'choose-item btn-item type_item' : 'btn-item type_item'"
        @click="changeModel('model2')">金属</div>
      <div :class="modelChoose === 'model3' ? 'choose-item btn-item type_item' : 'btn-item type_item'"
        @click="changeModel('model3')">金属（无钻）
      </div>
      <div class="btn-item" @click="changeColor(null)">重新加载</div>
      <div class="btn-item" @click="goAbout(true)">随机组合</div>
      <div class="btn-item" @click="goAbout">下一步</div>
    </div>
    <!-- PC端：保持原样 -->
    <div class="btn-list" v-if="!isMobile">
      <div v-for="(item, index) in model_list" :key="index"
        :class="rotation === item ? 'choose-item btn-item position_item' : 'btn-item position_item'"
        @click="changeRotation(item, index)">{{
          model_list[index] }}</div>
    </div>
    <!-- 移动端：带滚动按钮 -->
    <div class="btn-list-wrapper" v-else>
      <div class="scroll-btn scroll-btn-left" @click="scrollPositionList('left')">
        <span>‹</span>
      </div>
      <div class="btn-list-mobile" ref="positionList">
        <div v-for="(item, index) in model_list" :key="index"
          :class="rotation === item ? 'choose-item btn-item position_item' : 'btn-item position_item'"
          @click="changeRotation(item, index)">{{
            model_list[index] }}</div>
      </div>
      <div class="scroll-btn scroll-btn-right" @click="scrollPositionList('right')">
        <span>›</span>
      </div>
    </div>
    <div class="color-list">
      <div v-for="(item, index) in color_list" :key="index"
        :class="color === item ? 'color-item choose-color' : 'color-item'" @click="changeColor(item)"
        :style="`background-color: ${item}`"></div>
    </div>
    <div class="model-list">
      <div class="model-two" ref="modelTwo"></div>
      <div class="model-one" ref="modelOne"></div>
    </div>
  </div>
</template>

<script>
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import router from '@/router';
import { getExampleData, selectCode } from "@/services/apiMethods.js";

export default {
  name: 'HomeView',
  data() {
    return {
      loading: true,
      model1: {
        scene: null,
        camera: null,
        renderer: null,
        controls: null,
        loader: null,
        model: null,
        rotation: '',
      },
      model2: {
        scene: null,
        camera: null,
        renderer: null,
        controls: null,
        loader: null,
        model: null,
        rotation: '',
      },
      model: null,
      rotation: '位置一',
      rotation2: '',
      color: '#ffffff',
      color_list: [],
      model_list: [],
      model_list2: [],
      model_list3: [],
      choose_index: 0,
      modelChoose: 'model1',
      selectData: [],// 有钻选择数据
      wuzuanSelectData: [],// 无钻选择数据
      isHaveZuanshi: true,// 是否有钻石
      resultData: {},
      input: '',
      diamondId: '',
      userId: '',
      isMobile: window.innerWidth <= 768
    }
  },
  mounted() {
    this.initScene();
    this.setSelectData();
    this.saveData();
    this.extractIdFromUrl();
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth <= 768;
    },
    extractIdFromUrl() {
      const search = (typeof window !== 'undefined' && window.location && window.location.search) ? window.location.search : '';
      const params = new URLSearchParams(search);
      const diamondId = params.get('diamondId') || '';
      const userId = params.get('userId') || '';
      this.diamondId = diamondId;
      this.userId = userId;
      localStorage.setItem('diamondId', this.diamondId);
      localStorage.setItem('userId', this.userId);
    },
    async payServe() {
      const response = await getExampleData({
        materialType: this.isHaveZuanshi ? 'diamonds' : 'metals',
        resultDtoList: this.isHaveZuanshi ? this.selectData : this.wuzuanSelectData,
        diamondId: this.diamondId || '',
        userId: this.userId || '',
      });
      console.log(response, '-----------')
      if (response.code == 0) {
        this.resultData = response.data
      } else {
        this.resultData = {}
      }
      localStorage.setItem('resultData', JSON.stringify(this.resultData));
    },
    async queryResult() {
      let res = await selectCode(this.input);
      console.log(res, 'res=======')
      if (res.data) {
        this.suijiClickFun(res.data);
      }
    },
    saveData() {
      localStorage.setItem('selectData', JSON.stringify(this.selectData));
      localStorage.setItem('wuzuanSelectData', JSON.stringify(this.wuzuanSelectData));
      if (this.isHaveZuanshi) {
        localStorage.setItem('type', 1);
      } else {
        localStorage.setItem('type', 2);
      }
    },
    setSelectData() {
      let list = ['位置一', '位置二', '位置三', '位置四', '位置五', '位置六', '位置七', '位置八', '位置九'];
      this.selectData = [];
      this.wuzuanSelectData = [];
      for (let i = 0; i < list.length; i++) {
        let data = {
          position: list[i],
          zuanshicolor: '无色钻',
          zuanshicolor16: '#ffffff',
          zuanshiImg: 'z_wusezuan.png',
          jinshuColor: '黄金',
          jinshuColor16: '#e3c37c',
        }
        this.selectData.push(data);
        let data2 = {
          position: list[i],
          zuanshicolor: '',
          zuanshicolor16: '',
          zuanshiImg: '',
          jinshuColor: '黄金',
          jinshuColor16: '#e3c37c',
        }
        this.wuzuanSelectData.push(data2);
      }
      this.saveData()
    },
    async goAbout(flag = false) {
      if (flag == true) {
        console.log('随机组合一份结果');
        // let data = [];
        // let colorList1 = ['#ffffff', '#d2a0c6', '#83b9f4', '#e3da99'];
        // let imgList1 = ['z_wusezuan.png', 'z_fenzuan.png', 'z_lanzuan.png', 'z_huangzuan.png'];
        // let zuanshicolorList = ['无色钻', '粉钻', '蓝钻', '黄钻'];
        // let colorList2 = ['#adadaf', '#e3c37c', '#bd8674'];
        // let jinshuColorList = ['白金', '黄金', '玫瑰金'];

        // if (this.isHaveZuanshi) {
        //   this.selectData.map(item => {
        //     let randomNum = Math.floor(Math.random() * 3);
        //     let randomNum2 = Math.floor(Math.random() * 4);
        //     let obj = {
        //       position: item.position,
        //       zuanshicolor: zuanshicolorList[randomNum2],
        //       zuanshiImg: imgList1[randomNum2],
        //       jinshuColor: jinshuColorList[randomNum],
        //     }
        //     data.push(obj);
        //   })
        //   this.selectData = data;
        // } else {
        //   this.wuzuanSelectData.map(item => {
        //     let randomNum = Math.floor(Math.random() * 3);
        //     let obj = {
        //       position: item.position,
        //       zuanshicolor: '',
        //       zuanshiImg: '',
        //       jinshuColor: jinshuColorList[randomNum],
        //     }
        //     data.push(obj);
        //   })
        //   this.wuzuanSelectData = data;
        // }
        // this.saveData();
        // 触发按钮点击事件
        // 2层循环

        this.suijiClickFun('');
      } else {
        if (this.isHaveZuanshi) {
          console.log('有钻石选择的组合', this.selectData);
        } else {
          console.log('无钻石选择的组合', this.wuzuanSelectData);
        }
        router.push({
          path: '/about',
          query: {
            diamondId: this.diamondId || '',
            userId: this.userId || ''
          }
        });
      }
    },
    suijiClickFun(queryData) {
      let typeCheckDomList = Array.from(document.getElementsByClassName('type_item'));
      let positionCheckDomList = Array.from(document.getElementsByClassName('position_item'));
      typeCheckDomList.map((item1, index1) => {
        let flag = this.isHaveZuanshi;
        if (queryData) {
          flag = queryData.materialType == 'diamonds' ? true : false;
        }
        if ((flag && index1 <= 1) || (!flag && index1 > 1)) {
          item1.click();
          this.waitForDOMUpdate()
          let number = (index1 == 0) ? 4 : 3;
          let colorList1 = ['#ffffff', '#d2a0c6', '#83b9f4', '#e3da99'];
          let colorList2 = ['#adadaf', '#e3c37c', '#bd8674'];
          positionCheckDomList.map((item2, index2) => {
            item2.click();
            if (queryData) {
              let color;
              if ((index1 == 0)) {
                color = queryData.resultDtoList[index2].zuanshicolor16;
              } else {
                color = queryData.resultDtoList[index2].jinshuColor16
              }
              this.changeColor(color)
              return
            }
            let randomNum = Math.floor(Math.random() * number);
            let value = (index1 == 0) ? colorList1[randomNum] : colorList2[randomNum];
            console.log(value,'--------')
            this.changeColor(value)
          })
        };
      })
      this.saveData();
    },
    waitForDOMUpdate() {
      return new Promise((resolve) => {
        setTimeout(resolve, 0);
      });
    },
    //初始场景
    async initScene() {
      this.model1.scene = new THREE.Scene();
      this.model1.scene.background = new THREE.Color('#FFFFFF');
      // 创建加载管理器
      this.model1.loadingManager = new THREE.LoadingManager(() => {
        //this.loading = false; // 加载完成后，隐藏加载动画
      });
      this.model2.scene = new THREE.Scene();
      this.model2.scene.background = new THREE.Color('#FFFFFF');
      // 创建加载管理器
      this.model2.loadingManager = new THREE.LoadingManager(() => {
        this.loading = false; // 加载完成后，隐藏加载动画
      });
      this.initCamera();
      this.initRender();
      this.initControls();
      this.addLight();
      this.renderScene();
      this.createGlb();
      this.addLight2();

    },
    //初始化相机
    initCamera() {
      this.model1.camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
      this.model2.camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
      if (window.innerWidth < 1000) {
        this.model1.camera.position.x = -40;
        this.model1.camera.position.y = 30;
        this.model2.camera.position.x = -40;
        this.model2.camera.position.y = 30;
      } else {
        this.model1.camera.position.x = -50;
        this.model1.camera.position.y = 30;
        this.model2.camera.position.x = -50;
        this.model2.camera.position.y = 30;
      }
    },
    //初始化渲染器模型
    initRender() {
      if (window.innerWidth < 1000) {
        let width = 390;
        let height = 295;
        this.model1.renderer = new THREE.WebGLRenderer({ antialias: true });
        this.model1.renderer.setSize(width, height);
        const canvas = this.model1.renderer.domElement;
        canvas.style.width = width; // 使canvas宽度充满容器
        canvas.style.height = height; // 使canvas高度充满容器
        // 更新相机的长宽比
        this.model1.camera.aspect = width / height;
        this.model1.camera.updateProjectionMatrix(); //
        this.model1.renderer.shadowMap.enabled = true;
        this.$refs.modelOne.appendChild(canvas);
        this.model2.renderer = new THREE.WebGLRenderer({ antialias: true });
        this.model2.renderer.setSize(width, height);
        const canvas2 = this.model2.renderer.domElement;
        canvas2.style.width = width; // 使canvas宽度充满容器
        canvas2.style.height = height; // 使canvas高度充满容器

        // 更新相机的长宽比
        this.model2.camera.aspect = width / height;
        this.model2.camera.updateProjectionMatrix(); //
        this.model2.renderer.shadowMap.enabled = true;
        this.$refs.modelTwo.appendChild(canvas2);
      } else {
        let width = this.$refs.modelOne.offsetWidth;
        let height = this.$refs.modelOne.offsetHeight;
        this.model1.renderer = new THREE.WebGLRenderer({ antialias: true });
        this.model1.renderer.setSize(width, height);
        const canvas = this.model1.renderer.domElement;
        canvas.style.width = width; // 使canvas宽度充满容器
        canvas.style.height = height; // 使canvas高度充满容器
        // 更新相机的长宽比
        this.model1.camera.aspect = width / height;
        this.model1.camera.updateProjectionMatrix(); //
        this.model1.renderer.shadowMap.enabled = true;
        this.$refs.modelOne.appendChild(canvas);
        this.model2.renderer = new THREE.WebGLRenderer({ antialias: true });
        this.model2.renderer.setSize(width, height);
        const canvas2 = this.model2.renderer.domElement;
        canvas2.style.width = width; // 使canvas宽度充满容器
        canvas2.style.height = height; // 使canvas高度充满容器

        // 更新相机的长宽比
        this.model2.camera.aspect = width / height;
        this.model2.camera.updateProjectionMatrix(); //
        this.model2.renderer.shadowMap.enabled = true;
        this.$refs.modelTwo.appendChild(canvas2);
      }
    },
    //初始化控制器
    initControls() {

      this.model1.controls = new OrbitControls(this.model1.camera, this.model1.renderer.domElement);
      this.model1.controls.enableDamping = true;
      // 设置相机与目标之间的最小和最大距离
      this.model1.controls.distance = 40;
      this.model1.controls.minDistance = 30; // 最小距离
      this.model1.controls.maxDistance = 50; // 最大距离
      // 设置阻尼系数，使相机移动更加平滑
      this.model1.controls.dampingFactor = 0.25;
      this.model1.controls.enableZoom = true;
      this.model1.controls.enablePan = false;


      this.model2.controls = new OrbitControls(this.model2.camera, this.model2.renderer.domElement);
      this.model2.controls.enableDamping = true;
      this.model2.controls.minDistance = 30; // 最小距离
      this.model2.controls.maxDistance = 50; // 最大距离
      this.model2.controls.distance = 40;
      // 设置阻尼系数，使相机移动更加平滑
      this.model2.controls.dampingFactor = 0.25;

      this.model2.controls.enableZoom = true;
      this.model2.controls.enablePan = false;
    },
    //加载第一个模型模型
    createGlb() {
      let url = 'models/zzz.glb';
      this.model1.loader = new GLTFLoader(this.model1.loadingManager);
      this.loading = true;
      let modelList = ['独立件01_2002', '独立件02_2002', '独立件03_2002', '独立件04_2002', '独立件05_2002', '独立件06_2002', '独立件07_2002', '独立件08_2002', '独立件09_2002'];
      let model_list2 = ['钻石01_2001', '钻石02_2001', '钻石03_2001', '钻石04_2001', '钻石05_2001', '钻石06_2001', '钻石07_2001', '钻石08_2001', '钻石09_2001'];

      // 创建GLTF加载器，并设置加载管理器
      this.model1.loader.load(url, (gltf) => {
        // 打印模型结构
        gltf.scene.traverse((node) => {
          if (node.isMesh && modelList.some(model => model === node.name)) {
            node.visible = false;
          }
          if (node.isMesh && model_list2.some(model => model === node.name)) {
            // 创建新的材质并应用
            node.material = new THREE.MeshPhysicalMaterial({
              color: '#ffffff', // 钻石通常是白色的
              roughness: 0.3, // 钻石表面非常光滑，因此粗糙度很低
              metalness: 1, // 钻石看起来像金属，因此金属度很高
              ior: 2.42, // 钻石的折射率
              transmission: 10, // 钻石是透明的，因此传输度很高
              thickness: 1, // 钻石的厚度，可以根据模型大小调整
              //specularColor: new THREE.Color(value), // 镜面反射颜色
              specularIntensity: 1, // 镜面反射强度
              transparent: true, // 启用透明度
              opacity: 0.8
            });
          }
        });
        this.model1.model = gltf.scene;
        if (window.innerWidth < 1000) {
          gltf.scene.scale.set(20, 20, 20);
        } else {
          gltf.scene.scale.set(12, 12, 12);
        }
        gltf.scene.position.set(0, 0, 0);
        this.model1.scene.add(gltf.scene);
        this.createGlb2();
      }, undefined, (error) => { });
    },
    //加载第二个模型模型
    createGlb2() {
      let url = 'models/CCC.glb';
      this.model2.loader = new GLTFLoader(this.model2.loadingManager);
      this.loading = true;
      let modelList = ['独立件01002', '独立件02002', '独立件03002', '独立件04002', '独立件05002', '独立件06002', '独立件07002', '独立件08002', '独立件09002'];
      let model_list2 = ['钻石01001', '钻石02001', '钻石03001', '钻石04001', '钻石05001', '钻石06001', '钻石07001', '钻石08001', '钻石09001'];
      // 创建GLTF加载器，并设置加载管理器
      this.model2.loader.load(url, (gltf) => {
        // 打印模型结构
        gltf.scene.traverse((node) => {
          if (node.isMesh && modelList.some(model => model === node.name)) {
            node.visible = false;
          }
          if (node.isMesh && model_list2.some(model => model === node.name)) {
            // 创建新的材质并应用
            node.material = new THREE.MeshPhysicalMaterial({
              color: '#ffffff', // 钻石通常是白色的
              roughness: 0.3, // 钻石表面非常光滑，因此粗糙度很低
              metalness: 1, // 钻石看起来像金属，因此金属度很高
              ior: 2.42, // 钻石的折射率
              transmission: 10, // 钻石是透明的，因此传输度很高
              thickness: 1, // 钻石的厚度，可以根据模型大小调整
              //specularColor: new THREE.Color(value), // 镜面反射颜色
              specularIntensity: 1, // 镜面反射强度
              transparent: true, // 启用透明度
              opacity: 0.8
            });
          }
        });
        this.model2.model = gltf.scene;
        if (window.innerWidth < 1000) {
          gltf.scene.scale.set(20, 20, 20);
        } else {
          gltf.scene.scale.set(12, 12, 12);
        }
        gltf.scene.position.set(0, 0, 0);
        this.model2.scene.add(gltf.scene);
        this.changeModel('model1');
      }, undefined, (error) => { });
    },
    //添加光源
    addLight() {
      const hemiLight = new THREE.HemisphereLight(0xffffff, 0x444444);
      hemiLight.position.set(0, 1, 0);
      this.model1.scene.add(hemiLight);
      // 添加主光源
      const dirLight = new THREE.DirectionalLight('#ffffff', 2);
      dirLight.position.set(0, 500, 0);
      dirLight.target.position.set(5, 0, 0);
      this.model1.scene.add(dirLight);
      const directionalLight = new THREE.DirectionalLight('#ffffff', 2);
      directionalLight.position.set(0, 500, 0);
      this.model1.scene.add(directionalLight);
      const directionalLight2 = new THREE.DirectionalLight('#ffffff', 2);
      directionalLight2.position.set(500, 0, 0);
      this.model1.scene.add(directionalLight2);
      const directionalLight3 = new THREE.DirectionalLight('#ffffff', 2);
      directionalLight3.position.set(0, 0, 500);
      this.model1.scene.add(directionalLight3);
      const directionalLight4 = new THREE.DirectionalLight('#ffffff', 2);
      directionalLight4.position.set(0, -500, 0);
      this.model1.scene.add(directionalLight4);
      const directionalLight5 = new THREE.DirectionalLight('#ffffff', 2);
      directionalLight5.position.set(-500, 0, 0);
      this.model1.scene.add(directionalLight5);
      const directionalLight6 = new THREE.DirectionalLight('#ffffff', 2);
      directionalLight6.position.set(0, 0, -500);
      this.model1.scene.add(directionalLight6);
      const directionalLight7 = new THREE.DirectionalLight('#ffffff', 1);
      directionalLight7.position.set(500, 500, 500).normalize();
      this.model1.scene.add(directionalLight7);
    },
    //添加光源2
    addLight2() {
      const hemiLight = new THREE.HemisphereLight(0xffffff, 0x444444);
      hemiLight.position.set(0, 1, 0);
      this.model2.scene.add(hemiLight);
      // 添加主光源
      const dirLight = new THREE.DirectionalLight('#ffffff', 2);
      dirLight.position.set(0, 500, 0);
      dirLight.target.position.set(5, 0, 0);
      this.model2.scene.add(dirLight);

      const directionalLight = new THREE.DirectionalLight('#ffffff', 2);
      directionalLight.position.set(0, 500, 0);
      this.model2.scene.add(directionalLight);

      const directionalLight2 = new THREE.DirectionalLight('#ffffff', 2);
      directionalLight2.position.set(500, 0, 0);
      this.model2.scene.add(directionalLight2);

      const directionalLight3 = new THREE.DirectionalLight('#ffffff', 2);
      directionalLight3.position.set(0, 0, 500);
      this.model2.scene.add(directionalLight3);

      const directionalLight4 = new THREE.DirectionalLight('#ffffff', 2);
      directionalLight4.position.set(0, -500, 0);
      this.model2.scene.add(directionalLight4);

      const directionalLight5 = new THREE.DirectionalLight('#ffffff', 2);
      directionalLight5.position.set(-500, 0, 0);
      this.model2.scene.add(directionalLight5);

      const directionalLight6 = new THREE.DirectionalLight('#ffffff', 2);
      directionalLight6.position.set(0, 0, -500);
      this.model2.scene.add(directionalLight6);

      const directionalLight7 = new THREE.DirectionalLight('#ffffff', 1);
      directionalLight7.position.set(500, 500, 500).normalize();
      this.model2.scene.add(directionalLight7);
    },
    //渲染场景
    renderScene() {
      // 渲染场景
      const animate = () => {
        requestAnimationFrame(animate);
        this.model1.renderer.render(this.model1.scene, this.model1.camera);
        this.model1.controls.update();
        this.model2.renderer.render(this.model2.scene, this.model2.camera);
        this.model2.controls.update();
      };
      animate();
    },
    //选择模型
    changeModel(value) {
      this.modelChoose = value;
      let modelList;
      let modelList2

      let modelList3;
      let modelList4;
      if (value === 'model1') {
        this.color_list = ['#ffffff', '#d2a0c6', '#83b9f4', '#e3da99'];
        this.model_list = ['位置一', '位置二', '位置三', '位置四', '位置五', '位置六', '位置七', '位置八', '位置九'];
        this.model_list2 = ['钻石01_2001', '钻石02_2001', '钻石03_2001', '钻石04_2001', '钻石05_2001', '钻石06_2001', '钻石07_2001', '钻石08_2001', '钻石09_2001'];
        this.model_list3 = ['钻石01001', '钻石02001', '钻石03001', '钻石04001', '钻石05001', '钻石06001', '钻石07001', '钻石08001', '钻石09001'];
        modelList = ['独立件01_2002', '独立件02_2002', '独立件03_2002', '独立件04_2002', '独立件05_2002', '独立件06_2002', '独立件07_2002', '独立件08_2002', '独立件09_2002'];
        modelList2 = ['独立件01_2001', '独立件02_2001', '独立件03_2001', '独立件04_2001', '独立件05_2001', '独立件06_2001', '独立件07_2001', '独立件08_2001', '独立件09_2001'];

        modelList3 = ['独立件01002', '独立件02002', '独立件03002', '独立件04002', '独立件05002', '独立件06002', '独立件07002', '独立件08002', '独立件09002'];
        modelList4 = ['独立件01001', '独立件02001', '独立件03001', '独立件04001', '独立件05001', '独立件06001', '独立件07001', '独立件08001', '独立件09001'];
        this.isHaveZuanshi = true;
      } else if (value === 'model2') {
        this.color_list = ['#adadaf', '#e3c37c', '#bd8674'];
        this.model_list = ['位置一', '位置二', '位置三', '位置四', '位置五', '位置六', '位置七', '位置八', '位置九'];
        this.model_list2 = ['独立件01_2001', '独立件02_2001', '独立件03_2001', '独立件04_2001', '独立件05_2001', '独立件06_2001', '独立件07_2001', '独立件08_2001', '独立件09_2001'];
        this.model_list3 = ['独立件01001', '独立件02001', '独立件03001', '独立件04001', '独立件05001', '独立件06001', '独立件07001', '独立件08001', '独立件09001'];
        modelList = ['独立件01_2002', '独立件02_2002', '独立件03_2002', '独立件04_2002', '独立件05_2002', '独立件06_2002', '独立件07_2002', '独立件08_2002', '独立件09_2002'];
        modelList2 = ['钻石01_2001', '钻石02_2001', '钻石03_2001', '钻石04_2001', '钻石05_2001', '钻石06_2001', '钻石07_2001', '钻石08_2001', '钻石09_2001'];

        modelList3 = ['独立件01002', '独立件02002', '独立件03002', '独立件04002', '独立件05002', '独立件06002', '独立件07002', '独立件08002', '独立件09002'];
        modelList4 = ['钻石01001', '钻石02001', '钻石03001', '钻石04001', '钻石05001', '钻石06001', '钻石07001', '钻石08001', '钻石09001'];
        this.isHaveZuanshi = true;
      } else if (value === 'model3') {
        this.color_list = ['#adadaf', '#e3c37c', '#bd8674'];
        this.model_list = ['位置一', '位置二', '位置三', '位置四', '位置五', '位置六', '位置七', '位置八', '位置九'];
        this.model_list2 = ['独立件01_2002', '独立件02_2002', '独立件03_2002', '独立件04_2002', '独立件05_2002', '独立件06_2002', '独立件07_2002', '独立件08_2002', '独立件09_2002'];
        this.model_list3 = ['独立件01002', '独立件02002', '独立件03002', '独立件04002', '独立件05002', '独立件06002', '独立件07002', '独立件08002', '独立件09002'];
        modelList = ['独立件01_2001', '独立件02_2001', '独立件03_2001', '独立件04_2001', '独立件05_2001', '独立件06_2001', '独立件07_2001', '独立件08_2001', '独立件09_2001',
          '钻石01_2001', '钻石02_2001', '钻石03_2001', '钻石04_2001', '钻石05_2001', '钻石06_2001', '钻石07_2001', '钻石08_2001', '钻石09_2001'
        ];
        modelList2 = [];

        modelList3 = ['独立件01001', '独立件02001', '独立件03001', '独立件04001', '独立件05001', '独立件06001', '独立件07001', '独立件08001', '独立件09001',
          '钻石01001', '钻石02001', '钻石03001', '钻石04001', '钻石05001', '钻石06001', '钻石07001', '钻石08001', '钻石09001'
        ];
        modelList4 = [];
        this.isHaveZuanshi = false;
      }
      this.saveData();
      this.rotation = this.model_list[this.choose_index];
      this.model1.rotation = this.model_list2[this.choose_index];
      this.model2.rotation = this.model_list3[this.choose_index];
      this.model1.model.traverse((node) => {
        if (node.isMesh && modelList.some(model => model === node.name)) {
          node.visible = false;
        } else if (node.isMesh && this.model_list2.concat(modelList2).some(model => model === node.name)) {
          node.visible = true;
        }
      });
      this.model2.model.traverse((node) => {
        if (node.isMesh && modelList3.some(model => model === node.name)) {
          node.visible = false;
        } else if (node.isMesh && this.model_list3.concat(modelList4).some(model => model === node.name)) {
          node.visible = true;
        }
      });
    },
    //选择颜色
    changeColor(value) {
      this.color = value;
      if (value) {
        // 获取当前选择的模型
        let index = this.model_list.indexOf(this.rotation);

        if (this.modelChoose === 'model1') {
          // 设置钻石的相关属性
          this.selectData[index].zuanshicolor = (
            value == '#ffffff'
              ? '无色钻' :
              value == '#d2a0c6'
                ? '粉钻' :
                value == '#83b9f4'
                  ? '蓝钻' :
                  '黄钻'
          );
          this.selectData[index].zuanshicolor16 = value;
          this.selectData[index].zuanshiImg = (
            value == '#ffffff' ?
              'z_wusezuan.png' :
              value == '#d2a0c6' ?
                'z_fenzuan.png' :
                value == '#83b9f4' ?
                  'z_lanzuan.png' :
                  'z_huangzuan.png'
          );
        } else if (this.modelChoose === 'model2') {
          this.selectData[index].jinshuColor = (value == '#adadaf') ? '白金' : (value == '#e3c37c') ? '黄金' : '玫瑰金';
          this.selectData[index].jinshuColor16 = value;

        } else if (this.modelChoose === 'model3') {
          // 设置无钻石的相关属性
          this.wuzuanSelectData[index].jinshuColor = (value == '#adadaf') ? '白金' : (value == '#e3c37c') ? '黄金' : '玫瑰金';
          this.wuzuanSelectData[index].jinshuColor16 = value;
        }
        this.saveData();
        this.model1.model.traverse((node) => {
          if (node.isMesh && node.name === this.model1.rotation) {
            // 创建新的材质并应用
            if (this.modelChoose === 'model2' || this.modelChoose === 'model3') {
              node.material = new THREE.MeshStandardMaterial({
                color: value, // 设置颜色
                metalness: 1, // 设置金属度为1，表示这是金属
                roughness: 0.3,
              });
            } else {
              node.material = new THREE.MeshPhysicalMaterial({
                color: value, // 钻石通常是白色的
                roughness: 0.3, // 钻石表面非常光滑，因此粗糙度很低
                metalness: 1, // 钻石看起来像金属，因此金属度很高
                ior: 2.42, // 钻石的折射率
                transmission: 10, // 钻石是透明的，因此传输度很高
                thickness: 1, // 钻石的厚度，可以根据模型大小调整
                //specularColor: new THREE.Color(value), // 镜面反射颜色
                specularIntensity: 1, // 镜面反射强度
                transparent: true, // 启用透明度
                opacity: 0.8
              });
            }
          }
        });
        this.model2.model.traverse((node) => {
          if (node.isMesh && node.name === this.model2.rotation) {
            // 创建新的材质并应用
            if (this.modelChoose === 'model2' || this.modelChoose === 'model3') {
              node.material = new THREE.MeshStandardMaterial({
                color: value, // 设置颜色
                metalness: 1, // 设置金属度为1，表示这是金属
                roughness: 0.3,
              });
            } else {
              node.material = new THREE.MeshPhysicalMaterial({
                color: value, // 钻石通常是白色的
                roughness: 0.3, // 钻石表面非常光滑，因此粗糙度很低
                metalness: 1, // 钻石看起来像金属，因此金属度很高
                ior: 2.42, // 钻石的折射率
                transmission: 10, // 钻石是透明的，因此传输度很高
                thickness: 1, // 钻石的厚度，可以根据模型大小调整
                //specularColor: new THREE.Color(value), // 镜面反射颜色
                specularIntensity: 1, // 镜面反射强度
                transparent: true, // 启用透明度
                opacity: 0.8
              });
            }
          }
        });
      } else {
        //重置选择
        this.choose_index = 0;
        this.modelChoose = 'model1';
        this.color_list = ['#ffffff', '#d2a0c6', '#83b9f4', '#e3da99'];
        this.model1.rotation = '位置一';
        this.model2.rotation = '位置一';
        this.color = '#ffffff';
        this.model_list = ['位置一', '位置二', '位置三', '位置四', '位置五', '位置六', '位置七', '位置八', '位置九'];
        // 移除旧的模型
        this.model1.scene.remove(this.model1.model);
        this.model2.scene.remove(this.model2.model);
        this.createGlb();
        this.isHaveZuanshi = true;
        this.setSelectData();
      }
    },
    //选择物体
    changeRotation(value, index) {
      this.rotation = value;
      this.choose_index = index;
      this.rotation = this.model_list[this.choose_index];
      this.model1.rotation = this.model_list2[this.choose_index];
      this.model2.rotation = this.model_list3[this.choose_index];
      this.color = '';
      this.model1.model.traverse((node) => {
        if (node.isMesh && node.name === this.model1.rotation) {
          // 设置相机位置和目标点
          let position = new THREE.Vector3().copy(node.position);
          //设置缩放比
          position.multiplyScalar(100);
          this.model1.camera.position.copy(position);
          this.model1.camera.lookAt(0, 0, 0);
        }
      });
      this.model2.model.traverse((node) => {
        if (node.isMesh && node.name === this.model2.rotation) {

          // 设置相机位置和目标点
          let position = new THREE.Vector3().copy(node.parent.position);
          //设置缩放比
          position.multiplyScalar(100);
          this.model2.camera.position.copy(position);
          this.model2.camera.lookAt(0, 0, 0);
        }
      })
    },
    // 滚动位置列表
    scrollPositionList(direction) {
      if (!this.$refs.positionList) return;
      const container = this.$refs.positionList;
      const scrollAmount = 200; // 每次滚动200px
      if (direction === 'left') {
        container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      } else {
        container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      }
    }
  }
}
</script>
<style scoped lang="scss">
.home {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  overflow-x: hidden;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);

  .loader {
    border: 1rem solid #f3f3f3;
    border-top: 1rem solid #3498db;
    border-radius: 50%;
    width: 4rem;
    height: 4rem;
    animation: spin 2s linear infinite;
    position: absolute;
    top: calc(50% - 2rem);
    left: calc(50% - 2rem);
    z-index: 1000;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  // PC端：保持原样
  @media (min-width: 769px) {
    .choose-model {
      position: absolute;
      top: 2rem;
      left: 0;
      right: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      width: 100%;
      z-index: 100;
      padding: 0 1rem;

      > div:first-child {
        width: 200px;
        display: inline-block;
        margin-right: 20px;
      }

      .btn-item {
        margin-right: 1rem;
        padding: 0.5rem 1rem;
        border: 0.1rem solid #8f8f8f;
        border-radius: 0.2rem;
        margin-bottom: 0.4rem;
        cursor: pointer;
        background: #fff;
        color: #333;

        &:hover {
          background-color: #3f7cf5;
          color: #ffffff;
        }

        &:last-child {
          margin-right: 0;
        }
      }

      .choose-item {
        border: 1px solid #8f8f8f;
        background-color: #3f7cf5;
        color: #ffffff;
      }
    }
  }

  // PC端：保持原样
  @media (min-width: 769px) {
    .btn-list {
      position: absolute;
      bottom: 5rem;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      gap: 0.5rem;
      z-index: 100;
      width: auto;

      .btn-item {
        padding: 0.5rem 1rem;
        border: 0.1rem solid #8f8f8f;
        border-radius: 0.2rem;
        cursor: pointer;
        background: #fff;
        color: #333;
        white-space: nowrap;
        text-align: center;

        &:hover {
          background-color: #3f7cf5;
          color: #ffffff;
        }
      }

      .choose-item {
        border: 1px solid #8f8f8f;
        background-color: #3f7cf5;
        color: #ffffff;
      }
    }
  }

  // PC端：保持原样
  @media (min-width: 769px) {
    .model-list {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-left: 0; // 不需要为左侧留空间

      .model-one {
        width: 35%;
        height: 100%;
      }

      .model-two {
        width: 35%;
        height: 100%;
      }
    }
  }

  .btn-list-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    background: rgba(255, 255, 255, 0.95);
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
    z-index: 100;
    flex-shrink: 0;
    height: 50px;
    overflow: hidden;

    .scroll-btn {
      flex-shrink: 0;
      width: 32px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(63, 124, 245, 0.1);
      cursor: pointer;
      transition: all 0.3s ease;
      z-index: 10;
      user-select: none;

      span {
        font-size: 24px;
        color: #3f7cf5;
        font-weight: bold;
        line-height: 1;
      }

      &:hover {
        background: rgba(63, 124, 245, 0.2);
      }

      &:active {
        background: rgba(63, 124, 245, 0.3);
      }
    }

    .btn-list-mobile {
      flex: 1;
      display: flex;
      align-items: center;
      gap: 0.4rem;
      padding: 0.4rem 0.5rem;
      overflow-x: auto;
      overflow-y: hidden;
      scroll-behavior: smooth;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* IE and Edge */

      &::-webkit-scrollbar {
        display: none; /* Chrome, Safari, Opera */
      }

      .btn-item {
        padding: 0.35rem 0.7rem;
        border: 1px solid #d0d0d0;
        border-radius: 6px;
        cursor: pointer;
        font-size: 0.8rem;
        white-space: nowrap;
        transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
        background: #fff;
        color: #333;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        flex-shrink: 0;

        &:hover {
          background-color: #3f7cf5;
          color: #ffffff;
          border-color: #3f7cf5;
          box-shadow: 0 2px 6px rgba(63, 124, 245, 0.3);
        }

        &:active {
          transform: scale(0.98);
        }
      }

      .choose-item {
        background-color: #3f7cf5;
        color: #ffffff;
        border-color: #3f7cf5;
        box-shadow: 0 2px 6px rgba(63, 124, 245, 0.4);
      }
    }
  }

  // PC端：保持原样
  @media (min-width: 769px) {
    .color-list {
      position: absolute;
      bottom: 1rem;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      justify-content: center;
      align-items: center;
      width: auto;
      height: 3rem;
      z-index: 100;

      .color-item {
        margin-right: 1rem;
        width: 1.5rem;
        height: 1.5rem;
        border: 1px solid #8f8f8f;
        border-radius: 50%;
        cursor: pointer;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

        &:last-child {
          margin-right: 0;
        }
      }

      .choose-color {
        width: 1.9rem;
        height: 1.9rem;
        border: 1px solid #8f8f8f;
        border-radius: 50%;
        cursor: pointer;
      }
    }
  }

  // 移动端优化
  @media (max-width: 768px) {
    .home {
      display: flex;
      flex-direction: column;
      overflow-x: hidden;
      background: #ffffff; // 移动端使用白色背景
    }

    .choose-model {
      position: relative;
      padding: 0.5rem;
      flex-shrink: 0;
      background: #ffffff;
      border-bottom: 1px solid #f0f0f0;
      width: 100%;
      box-sizing: border-box;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
      gap: 0.4rem;

      // 输入框占一半宽度
      > div:first-child {
        width: calc(50% - 0.2rem) !important;
        max-width: calc(50% - 0.2rem) !important;
        margin-right: 0 !important;
        margin-bottom: 0 !important;
        display: block !important;
        order: -1; // 确保输入框在第一行
      }

      // 查询按钮紧跟在输入框后面，第一行
      > div:nth-child(2) {
        flex-shrink: 0;
        order: -1; // 和输入框在同一行
      }

      // 其他按钮在第二行
      > div:nth-child(n+3) {
        order: 0; // 其他按钮在第二行
      }

      .btn-item {
        padding: 0.4rem 0.8rem;
        font-size: 0.75rem;
        border: 1px solid #d0d0d0;
        border-radius: 6px;
        background: #fff;
        color: #333;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        transition: all 0.3s ease;
        white-space: nowrap;
        cursor: pointer;
        flex-shrink: 0;
        margin: 0;

        &:hover {
          background-color: #3f7cf5;
          color: #ffffff;
          border-color: #3f7cf5;
        }
      }

      .choose-item {
        background-color: #3f7cf5;
        color: #ffffff;
        border-color: #3f7cf5;
      }
    }

    .model-list {
      flex: 1;
      height: calc(100% - 180px);
      display: flex;
      flex-direction: column;
      gap: 0;
      padding: 0;
      overflow: hidden;
      min-height: 0;
      padding-left: 0; // 移动端不需要左侧padding
      width: 100%;
      background: #ffffff;

      .model-one,
      .model-two {
        width: 100%;
        height: 50%;
        overflow: hidden;
        flex-shrink: 0;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #ffffff;
      }
    }

    .btn-list-wrapper {
      height: 50px;
      flex-shrink: 0;
      background: #ffffff;
      border-bottom: 1px solid #f0f0f0; // 添加分隔线，避免遮挡

      .scroll-btn {
        width: 32px;

        span {
          font-size: 24px;
        }
      }

      .btn-list-mobile {
        padding: 0.4rem 0.5rem;
        gap: 0.4rem;

        .btn-item {
          padding: 0.35rem 0.7rem;
          font-size: 0.8rem;
        }
      }
    }

    .color-list {
      position: relative;
      padding: 0.3rem 0.5rem;
      height: 45px;
      flex-shrink: 0;
      background: #ffffff;
      border-top: 1px solid #f0f0f0; // 添加分隔线，避免遮挡
      gap: 0.5rem;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;

      .color-item {
        width: 1.5rem;
        height: 1.5rem;
        border: 2px solid #d0d0d0;
        border-radius: 50%;
        transition: border-color 0.3s ease, box-shadow 0.3s ease;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        flex-shrink: 0;
        margin-right: 0;
        cursor: pointer;

        &:hover {
          border-color: #3f7cf5;
          box-shadow: 0 2px 6px rgba(63, 124, 245, 0.3);
        }
      }

      .choose-color {
        width: 1.8rem;
        height: 1.8rem;
        border: 3px solid #3f7cf5;
        box-shadow: 0 2px 8px rgba(63, 124, 245, 0.4);
      }
    }
  }

  // 小屏幕手机优化
  @media (max-width: 480px) {
    .home {
      background: #ffffff;
    }

    .choose-model {
      padding: 0.4rem;
      background: #ffffff;
      gap: 0.3rem;
      top: 0;

      // 输入框占一半宽度
      > div:first-child {
        width: calc(50% - 0.15rem) !important;
        max-width: calc(50% - 0.15rem) !important;
        margin-right: 0 !important;
        margin-bottom: 0 !important;
      }

      // 查询按钮紧跟在输入框后面，第一行
      > div:nth-child(2) {
        flex-shrink: 0;
      }

      // 其他按钮在第二行
      > div:nth-child(n+3) {
        order: 0;
      }

      .btn-item {
        padding: 0.3rem 0.5rem;
        font-size: 0.7rem;
        margin: 0;
      }
    }

    .btn-list-wrapper {
      height: 45px;
      background: #ffffff;

      .scroll-btn {
        width: 28px;

        span {
          font-size: 20px;
        }
      }

      .btn-list-mobile {
        .btn-item {
          padding: 0.3rem 0.5rem;
          font-size: 0.7rem;
        }
      }
    }

    .color-list {
      height: 40px;
      padding: 0.3rem 0.4rem;
      background: #ffffff;

      .color-item {
        width: 1.3rem;
        height: 1.3rem;
      }

      .choose-color {
        width: 1.6rem;
        height: 1.6rem;
      }
    }
  }
}
</style>
